import styled from '@emotion/styled';
import { LegendBaseProps } from './ChartLegend';

export interface CompleteLegendProps extends LegendBaseProps {}

const CompleteLegend = ({ data, colors, mouseOverCallback, mouseLeaveCallback }: CompleteLegendProps) => {
  return (
    <Legend>
      {data.labels.map((label, index) => (
        <LegendItem key={label} onMouseOver={() => mouseOverCallback(index)} onMouseLeave={() => mouseLeaveCallback()}>
          <ColoredCircle start={colors[index % colors.length].start} end={colors[index % colors.length].end} />
          <Key>
            <Number>{data.values[index].toLocaleString()}</Number>
            <Label>{label}</Label>
          </Key>
        </LegendItem>
      ))}
    </Legend>
  );
};

export default CompleteLegend;

const Legend = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing(2)};
`;

const LegendItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  column-gap: ${({ theme }) => theme.spacing(2)};
`;

const ColoredCircle = styled.div<{ start: string; end: string }>`
  height: ${({ theme }) => theme.spacing(2)};
  width: ${({ theme }) => theme.spacing(2)};
  border-radius: 50%;
  background: ${({ start, end }) => `linear-gradient(145deg, ${start} 0%, ${end} 100%)`};
  margin-bottom: 3px;
`;

const Key = styled.div`
  display: flex;
  flex-direction: column;
  opacity: 0.7;
  text-align: left;
`;

const Number = styled.div`
  font-size: 1.5rem;
  font-weight: 800;
`;

const Label = styled.div``;
